import object from 'helpers/object'


export const initialState = {
  trainersParams: {},
  trainers: [],
  isFetching: true,
}


export const setTrainers = (state, payload) => (
  object.setIn(state, [ 'trainers' ], payload)
)

export const setFetching = (state, payload) => (
  object.setIn(state, [ 'isFetching' ], payload)
)

export const setTrainersParams = (state, payload) => (
  object.setIn(state, [ 'trainersParams' ], payload)
)
